/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { Typography, Box } from '@mui/material';
import { fonts } from '../themes/themes';

interface CircleChartProps {
  data: { name: string; value: number }[];
  colors: string[];
}

const CircleChart: React.FC<CircleChartProps> = ({ data, colors }) => {
  return (
    <Box>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box style={{ width: '40%', height: '100%' }}>
          <PieChart width={300} height={300}>
            <Pie
              data={data}
              cx={85}
              cy={120}
              innerRadius={60}
              outerRadius={80}
              fill="#8884d8"
              paddingAngle={0}
              dataKey="value"
              nameKey="name"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip />{' '}
            {/* Add this to display tooltips with label and value on hover */}
          </PieChart>
        </Box>
        <Box>
          <Typography
            style={{
              display: 'flex',
              color: '#9E9E9E',
              fontSize: '0.85em',
              fontFamily: fonts.fontFamily,
            }}
          >
            {' '}
            2 Pending
          </Typography>
          <Typography
            style={{
              display: 'flex',
              color: '#9E9E9E',
              fontSize: '0.85em',
              fontFamily: fonts.fontFamily,
            }}
          >
            {' '}
            4 In-progress
          </Typography>
          <Typography
            style={{
              display: 'flex',
              color: '#9E9E9E',
              fontSize: '0.85em',
              fontFamily: fonts.fontFamily,
            }}
          >
            {' '}
            12 Active
          </Typography>
        </Box>
      </Box>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {data?.map((d: any, index: any) => {
          return (
            <Box key={index} style={{ display: 'flex', alignItems: 'center' }}>
              <Box
                style={{
                  width: '1em',
                  height: '1em',
                  backgroundColor: colors[index],
                }}
              />
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: '0.75em',
                  color: '#131523',
                  fontWeight: 'bold',
                  marginLeft: '0.2em',
                }}
              >
                {d?.name}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CircleChart;
